







































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ContactsSearch from "../../records/contacts/ContactsSearch.vue";

@Component({
  components: {
    ContactsSearch: ContactsSearch
  }
})
export default class SearchContactModal extends Vue {
  @Prop({ default: {} }) addressData: any;

  nameSelected = 1 as number;

  get addressesPickups() {
    if (this.$store.getters["customer/config"].pickupEnabled) {
      return [
        {
          name: "addresses",
          key: 1
        },
        {
          name: "pickups",
          key: 2
        }
      ];
    }
    return [];
  }

  isActive(item: any): boolean {
    return item.key === this.nameSelected;
  }

  updateSelected(item: any) {
    this.nameSelected = item.key;
  }
}
